import { GetterTree } from 'vuex';
import { IThresholdState } from './threshold.types';
import { EThresholdGetter } from './threshold.constants';
import { RootState } from '@/store/store';
import { EnumPlans } from '@/enums/Plans';

export const getters: GetterTree<IThresholdState, RootState> = {
  [EThresholdGetter.IsNearThresholdLimit](state, _, rootState): boolean {
    const { plan } = rootState['session'].session;
    const documentCount = state.activeDocumentThreshold?.documentCount;
    if (!documentCount) {
      return false;
    }
    switch (plan) {
      case EnumPlans.free:
        return documentCount > 1;
      case EnumPlans.essential:
        return documentCount > 7;
      default:
        return false;
    }
  },
};
